export const SET_AUTOGENERATED_VALUES = "setautogeneratedValues";
